import { DELIMITER, DISABLE, ENABLED, SUBSTRING } from '../../utilities/Constants';
import { IMapping } from './ScannerFormData';
export interface IScannerViewData {
    id: string;
    name: string;
    scannerContent: string;
    isDelimited: boolean;
    delimiter: string;
    mappings: IMapping[];
    isEnabled: boolean;
    delimiterValue: string;
    enableValue: string;
}

export default class ScannerViewData implements IScannerViewData {
    id: string;
    name: string;
    scannerContent: string;
    isDelimited: boolean;
    delimiter: string;
    mappings: IMapping[];
    isEnabled: boolean;
    delimiterValue: string;
    enableValue: string;

    constructor(id: string,
        name: string,
        scannerContent: string,
        isDelimited: boolean,
        delimiter: string,
        mappings: IMapping[],
        isEnabled: boolean) {
        this.id = id;
        this.name = name;
        this.scannerContent = scannerContent;
        this.isDelimited = isDelimited;
        this.delimiter = delimiter;
        this.mappings = mappings;
        this.isEnabled = isEnabled;
        this.delimiterValue = this.isDelimited ? DELIMITER : SUBSTRING;
        this.enableValue = this.isEnabled ? ENABLED : DISABLE;
    }
}

const defaultScannerViewData = new ScannerViewData("", "", "", false, "", [], false);
export { defaultScannerViewData };
